'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "clone-dashboard-dialog" */
'dashboard-components/dashboard-actions/prompts/CloneDashboardDialogContainer').then(module => module.CloneDashboardDialogContainer);
export default Loadable({
  loader,
  LoadingComponent: () => null
});